import { not } from "~/utils"
import type { PublicEnvsSchema } from "~/utils/env.types"

export const envClient = (envVar: PublicEnvsSchema): string => {
  window.ENV = window.ENV ?? {}
  const ev = window.ENV[envVar]
  if (not(ev)) {
    throw new Error(`process.env.${envVar} is not set.`)
  }
  return ev
}
